import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;



export const fetchServiceById = (accessToken, id) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "service_select",
            "action": "SELECT_BY_SERVICE_ID",
            "findOne": "true",
            "variables": JSON.stringify({
                'id_product_service': id
            })
        })
    });
};

export const fetchByCode = (accessToken, variables) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "product_service_select",
            "action": "SELECT_BY_SERVICE_CODE",
            "variables": JSON.stringify(variables)
        })
    });
};


export const insertDataService = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        data: JSON.stringify({
            process: "product_service_alter",
            action: "INSERT",
            variables: data
        })
    })
};


export const updateService = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "product_service_alter",
            'action': "UPDATE",
            "variables": data
        })
    });
};


export const fetchServiceJson = (work_flow, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "company_action_selection_select",
            'action': "SELECT_ID",
            'variables': JSON.stringify({ 'work_flow': work_flow })
        })
    });
};


export const fetchStorages = (id_product_service, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "service_select",
            'action': "SELECT_STORAGES",
            'variables': JSON.stringify({ 'id_product_service': id_product_service })
        })
    });
};
export const updateStorage = (id_product_service, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "",
            'action': "",
            'variables': JSON.stringify({ 'id_product_service': id_product_service })
        })
    });
};
export const deleteStorage = (id_product_service, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "",
            'action': "",
            'variables': JSON.stringify({ 'id_product_service': id_product_service })
        })
    });
};

export const getCompanies = (id_user_action, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'user_select',
            'action': 'SELECTCOMPANIES_SERVICES',
            'variables': JSON.stringify({ 'id_user_action': id_user_action })
        })
    })
}


 